
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { library, icon } from '@fortawesome/fontawesome-svg-core';
import { faTwitter, faFacebook } from '@fortawesome/free-brands-svg-icons';
import { faShareAlt, faCopy, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { faCopy as faCopyRegular } from '@fortawesome/free-regular-svg-icons';

import { ShareMethod } from '@/enums/share-methods';

library.add(faShareAlt, faCopy, faCopyRegular, faTwitter as IconDefinition, faFacebook as IconDefinition);

@Component({
	name: 'TitleShareButton',
})
export default class TitleShareButton extends Vue {
	twitterIcon = icon({ prefix: 'fab', iconName: 'twitter' });
	facebookIcon = icon({ prefix: 'fab', iconName: 'facebook' });
	farCopyIcon = icon({ prefix: 'far', iconName: 'copy' });

	@Prop({ default: undefined }) iconSize: string | undefined;
	@Prop({ default: true }) showShareText: boolean;

	shareTitle(method: ShareMethod | undefined) {
		if (this.isNativeSharingSupported) {
			this.$emit('share');
			return;
		}
		this.$emit('share', method);
	}

	get isNativeSharingSupported(): boolean {
		if (process.server) {
			return false;
		}
		return true;
	}
}
